import React, { useRef } from 'react'
import merge from 'deepmerge'
import HighchartsReact from 'highcharts-react-official'
import { equals, omit } from 'ramda'

import { useExport } from '../../contexts/ExportContext'
import Highcharts from '../../highcharts'
import { addImageToClipboard } from '../../utils/export'

interface Props {
  chartProps: HighchartsReact.Props
}

const RegularChart: React.FC<Props> = React.memo((props) => {
  const exportContext = useExport()
  const chartRef = useRef<Highcharts.Chart>()

  const defaultProps = {
    constructorType: 'chart',
    options: {
      exporting: {
        buttons: {
          contextButton: {
            menuItems: [
              'viewFullscreen',
              'printChart',
              ...(equals<any>(exportContext, {}) ? [] : ['addToExportQueue']),
              'addToClipboard',
              'separator',
              'downloadPNG',
              'downloadJPEG',
              'downloadPDF',
              'downloadSVG',
              'separator',
              'downloadCSV',
              'downloadXLS',
            ],
          },
        },
        menuItemDefinitions: {
          addToExportQueue: {
            text: 'Adicionar à fila de exportação',
            onclick: () => {
              chartRef.current && exportContext.addToQueue(chartRef.current)
            },
          },
          addToClipboard: {
            text: 'Copiar para o clipboard',
            onclick: () =>
              chartRef.current &&
              addImageToClipboard(chartRef.current.container).catch((err) =>
                console.error(err)
              ),
          },
        },
      },
      stockTools: {
        gui: {
          enabled: false,
        },
      },
    },
    containerProps: {
      style: {
        position: 'relative',
      },
    },
  }

  const onChartReady = (chart: Highcharts.Chart) => {
    if (props.chartProps.callback) {
      props.chartProps.callback(chart)
    }
    chartRef.current = chart
  }

  return (
    <HighchartsReact
      highcharts={Highcharts}
      {...merge(defaultProps, omit(['highcharts'], props.chartProps))}
      callback={onChartReady}
    />
  )
})

export default RegularChart
